export const getAutoPlayLayoutStyles = () => ({
  '@keyframes animationIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes animationOut': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
  layoutContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  activePlacement: {
    opacity: 1,
  },
  animationInPlacement: {
    animation: '$animationIn 1s forwards',
  },
  animationOutPlacement: {
    animation: '$animationOut 0.5s forwards',
  },
  hiddenPlacement: {
    display: 'none',
  },
  slideContainer: {
    marginTop: '36px',
    marginLeft: '5px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  activeProgressBar: {
    height: '140px',
    marginBottom: '10px',
  },
  progressBar: {
    height: '18px',
    marginBottom: '10px',
  },
});
